export const AI_OUTPUT_LEAVE_TAB_DIALOG_CONTENT =
	'You’re currently editing a section. Do you wish to save changes before switching tabs?';

export const AI_OUTPUT_LEAVE_EDIT_DIALOG_CONTENT =
	'You’re currently editing a section. If you click on cancel all changes will be lost?';
